import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/data/fleet";
import { mosaicGradient } from "@/components/motion/Tiles";

export const VehicleCard = ({ vehicle: v, testId }) => {
  const cat = CATEGORIES[v.category];
  return (
    <Link
      to={`/parco-mezzi/${v.category}/${v.slug}`}
      className="group relative flex h-full flex-col border border-ink/10 bg-white transition-[transform,box-shadow,border-color] duration-500 ease-out hover:-translate-y-1.5 hover:border-ink/20 hover:shadow-[0_30px_60px_-30px_rgba(18,22,26,0.35)]"
      data-testid={testId || `fleet-card-${v.slug}`}
    >
      <span aria-hidden className="absolute inset-x-0 top-0 z-10 h-1 origin-left scale-x-0 transition-transform duration-500 ease-out group-hover:scale-x-100" style={{ backgroundImage: mosaicGradient(10) }} />
      <div className="relative aspect-[4/3] overflow-hidden bg-ink">
        <img src={v.image} alt={v.name} style={{ objectPosition: v.imagePosition }} className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
        <span className="absolute left-4 top-4 bg-white/95 px-2.5 py-1 font-mono text-[10px] font-semibold uppercase tracking-widest text-ink" style={{ borderLeft: `3px solid ${cat.accent}` }}>
          {v.type}
        </span>
        {v.units > 1 && (
          <span className="absolute right-4 top-4 bg-blue-600 px-2.5 py-1 font-mono text-[10px] font-semibold uppercase tracking-widest text-white">
            {v.units} unità
          </span>
        )}
        <div className="absolute bottom-4 left-4 text-white">
          <p className="font-mono text-[10px] uppercase tracking-widest text-white/60">{v.highlight.label}</p>
          <p className="font-display text-3xl font-extrabold leading-none">{v.highlight.value}</p>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <p className="font-mono text-[10px] uppercase tracking-widest text-blue-600">{v.brand}</p>
        <h3 className="display mt-1 text-2xl text-ink">{v.model}</h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-ink/60">{v.summary}</p>
        <div className="mt-5 flex items-center justify-between border-t border-ink/10 pt-4">
          <div className="flex flex-wrap gap-1.5">
            {v.tags.slice(0, 2).map((t) => (
              <span key={t} className="bg-paper px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-ink/60">{t}</span>
            ))}
          </div>
          <span className="flex h-9 w-9 shrink-0 items-center justify-center border border-ink/15 text-ink transition-[background-color,border-color,color] duration-300 group-hover:border-blue-600 group-hover:bg-blue-600 group-hover:text-white">
            <ArrowUpRight className="h-4 w-4" />
          </span>
        </div>
      </div>
    </Link>
  );
};
